import { IS_CUSTOM_PAGE } from 'Store/CustomPage/CustomPage.action';

const initialState = {
    customPage: {
        isCustom: false,
        name: null
    }
};

const CustomPageReducer = (state = initialState, action) => {
    switch (action.type) {
        case IS_CUSTOM_PAGE:
            return {
                ...state,
                customPage: {
                    ...state.customPage,
                    ...action.customPage
                }
            };
        default:
            return state;
    }
};

export default CustomPageReducer;
